import { Col, Form, Input, Row } from 'antd';
import PrintIcon from 'icons/print.svg';
import { filterDigits, localize } from 'mixins/helpers';
import Button from 'mixins/ui/button/button';
import CmsTable from 'mixins/ui/cms-table';
import PartWrapper from 'mixins/ui/part-wrapper';
import PrintForm2 from 'mixins/ui/print-form-2';
import React, { useRef, useState } from 'react';
import service from '../../../react4xp/services/isnaportalsync';
import './check-kkm-reg.scss';
import { Recaptcha, RecaptchaWrapper } from '/react4xp/mixins/ui/recaptcha-v3';
import captchaTokenService from '/react4xp/services/captcha-token-service';

const CheckKkmReg = (props: any) => {
    const { code, registrationNumber } = props.config;
    const [loading, setLoading] = useState(false);
    const [printUrl, setPrintUrl] = useState<string>();
    const [tableLoading, setTableLoading] = useState(false);
    const [data, setData] = useState<Array<any>>([]);
    const [form] = Form.useForm();
    const captchaRef = useRef(null);

    const columns = [
        {
            title: localize('title', props.translations),
            dataIndex: 'ru',
        },
        {
            title: localize('iin-bin', props.translations),
            dataIndex: 'code',
        },
        {
            title: localize('kmp-register-number', props.translations),
            dataIndex: 'registrationNumber',
        },
        {
            title: localize('kkm-register-date', props.translations),
            dataIndex: 'beginDate',
            render: (beginDate) =>
                beginDate && beginDate.substring(0, 10).split('-').reverse().join('.'),
        },
        {
            title: localize('kkm-address-of-use', props.translations),
            dataIndex: 'addressFullRu',
            render: (addressFullRu, row) =>
                addressFullRu ||
                [row.streetName, row.buildingNumber, row.apartmentNumber].join(' '),
        },
        {
            title: localize('deregistraion-date', props.translations),
            dataIndex: 'endDate',
            render: (endDate) => endDate && endDate.substring(0, 10).split('-').reverse().join('.'),
        },
    ];

    const onFinish = (values: any) => {
        if (captchaTokenService.isVerified()) {
            setLoading(true);

            let reqParams = `code=${values.code}&registrationNumber=${values.registrationNumber}`;
            //reqParams += '&clientRecaptchaResponse=' + loadCaptcha();
            service
                .checkKkmRegistry(reqParams)
                .then((res) => {
                    setData(res.data);
                    setTableLoading(true);
                })
                .finally(() => captchaRef.current?.updateToken());
            setPrintUrl(`/services/isnaportalsync/open-api/kkm-state-registry/pdf?${reqParams}`);
            setLoading(false);
        }
    };

    return (
        <>
            <Recaptcha ref={captchaRef} />
            <div className="check-kkm-reg">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    className="mb-4"
                >
                    <Row gutter={16}>
                        <Col
                            xs={24}
                            md={6}
                            lg={6}
                        >
                            <Form.Item
                                label={code}
                                name="code"
                                rules={[
                                    {
                                        required: true,
                                        message: localize(
                                            'error.field-is-required',
                                            props.translations
                                        ),
                                    },
                                    {
                                        min: 12,
                                        message: localize(
                                            'iin.enter-twelve-digits',
                                            props.translations
                                        ),
                                    },
                                ]}
                            >
                                <Input
                                    size="large"
                                    placeholder={localize('placeholder.input', props.translations)}
                                    onChange={filterDigits(form, 'code')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                        <Col
                            xs={24}
                            md={8}
                            lg={8}
                        >
                            <Form.Item
                                label={registrationNumber}
                                name="registrationNumber"
                                rules={[
                                    {
                                        required: true,
                                        message: localize(
                                            'error.field-is-required',
                                            props.translations
                                        ),
                                    },
                                ]}
                            >
                                <Input
                                    size="large"
                                    placeholder={localize('placeholder.input', props.translations)}
                                    onChange={filterDigits(form, 'registrationNumber')}
                                    maxLength={12}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <hr className="my-3" />

                    <Row gutter={[16, { md: 24, xs: 24, lg: 24 }]}>
                        <Col>
                            <Button
                                onClick={() => {
                                    form.resetFields();
                                    setLoading(false);
                                    setData(null);
                                    setTableLoading(false);
                                }}
                            >
                                {localize('button.reset', props.translations)}
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                color="gold"
                                htmlType="submit"
                                loading={loading}
                            >
                                {localize('button.find', props.translations)}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
            {data && loading === false && tableLoading && (
                <>
                    <CmsTable
                        columns={columns}
                        type="default"
                        dataSource={data}
                        size="small"
                        translations={props.translations}
                    />
                    {data.length > 0 && (
                        <Row
                            gutter={15}
                            justify="end"
                            className="mt-3"
                        >
                            <Col>
                                <PrintForm2
                                    apiUrl={printUrl}
                                    icon={<PrintIcon />}
                                    translations={props.translations}
                                />
                            </Col>
                        </Row>
                    )}
                </>
            )}
        </>
    );
};

export default (props) => (
    <PartWrapper {...props}>
        <RecaptchaWrapper>
            <CheckKkmReg {...props} />
        </RecaptchaWrapper>
    </PartWrapper>
);
